import {
  Box,
  Button,
  Checkbox,
  Popover,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { IOptionRatingCheckbox } from 'src/components/AdvanceSearchEcommerce';
import { reducerUpdateAdvanceSearch } from 'src/features/advanceSearchEcommerce';
import FloatingLabelButton from '../FloatingLabelButton';

export default function FilterRating() {
  const { userRating } = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );

  const [streamRatingOptions, setRatingOptions] = useState<
    Array<IOptionRatingCheckbox>
  >([
    {
      id: 1,
      name: 1,
      label: '1 ⭐️',
      isChecked: userRating.includes(1)
    },
    {
      id: 2,
      name: 2,
      label: '2 ⭐️⭐️',
      isChecked: userRating.includes(2)
    },
    {
      id: 3,
      name: 3,
      label: '3 ⭐️⭐️⭐️',
      isChecked: userRating.includes(3)
    },
    {
      id: 4,
      name: 4,
      label: '4 ⭐️⭐️⭐️⭐️',
      isChecked: userRating.includes(4)
    },
    {
      id: 5,
      name: 5,
      label: '5 ⭐️⭐️⭐️⭐️⭐️',
      isChecked: userRating.includes(5)
    }
  ]);

  const theme = useTheme();

  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const dispatch = useAppDispatch();

  const advanceSearchEcommerce = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleRatingCheckChange = (
    rating: IOptionRatingCheckbox,
    checked: boolean
  ) => {
    if (checked) {
      setRatingOptions(
        streamRatingOptions.map((item) => {
          return {
            ...item,
            isChecked: rating.id === item.id ? true : item.isChecked
          };
        })
      );
    } else {
      setRatingOptions(
        streamRatingOptions.map((item) => {
          return {
            ...item,
            isChecked: rating.id === item.id ? false : item.isChecked
          };
        })
      );
    }
  };

  const handleApply = () => {
    dispatch(
      reducerUpdateAdvanceSearch({
        ...advanceSearchEcommerce,
        userRating: streamRatingOptions
          .filter((item) => item.isChecked)
          .map((val) => val.id)
      })
    );
    handleClose();
  };

  return (
    <>
      <Stack maxWidth="400px" width="100%" spacing={0.5}>
        <FloatingLabelButton
          chipList={streamRatingOptions
            .filter((item) => item.isChecked)
            .map((item) => item.label)}
          label="Rating"
          onClick={handleOpen}
          open={open}
        />
      </Stack>
      <Popover
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Box sx={{ p: theme.spacing(2), maxWidth: '600px', width: '100%' }}>
          <Box sx={{ maxHeight: '300px', overflow: 'auto' }}>
            <>
              {streamRatingOptions.map((row) => (
                <Stack
                  direction="row"
                  gap={0.5}
                  key={row.id}
                  alignItems="center"
                >
                  <Checkbox
                    color="primary"
                    checked={row.isChecked}
                    onChange={(event) =>
                      handleRatingCheckChange(row, event.target.checked)
                    }
                  />
                  <Typography>{row.label}</Typography>
                </Stack>
              ))}
            </>
          </Box>
          <Stack pt={2} alignItems="center">
            <Button variant="contained" onClick={handleApply}>
              Apply
            </Button>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
